import "./utils/newRelic";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";

import App from "./App";

import reportWebVitals from "./reportWebVitals";
import SearchState from "./contexts/searchContext";
import { persistor, store } from "./store/store";
import theme from "./theme";
import { AUTO_HIDE_DURATION } from "./constants";
import { googleClientId } from "./constants/auth";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import GtmLoader from "./utils/gtm";

const gtmSrc = process.env.REACT_APP_GTM_SRC as string;
const env = process.env.REACT_APP_ENV;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GoogleOAuthProvider clientId={googleClientId}>
          <BrowserRouter>
            <SearchState>
              <GtmLoader gtmSrc={gtmSrc} env={env} />
              <SnackbarProvider
                autoHideDuration={AUTO_HIDE_DURATION}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              />
              <App />
            </SearchState>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>,
);

reportWebVitals();
